import { io } from 'socket.io-client';

const URL = window.location.hostname === 'localhost'
    ? 'http://localhost:5000'
    : window.location.origin;

let socket = null;

export function getSocket() {
    if (!socket) {
        socket = io(URL, {
            // Server's io.use verifies this
            auth: { token: localStorage.getItem('token') },
        });

        socket.on('connect', () => console.log('✅ socket connected:', socket.id));
        socket.on('connect_error', (e) => console.error('❌ socket connect_error:', e.message));
    }
    return socket;
}

// Tell the other members in this trip room that we just saved a change
let lastChangeSentAt = 0;
const CHANGE_THROTTLE_MS = 2000;

export function broadcastChange() {
    if (!socket || !socket.connected) return;
    const now = Date.now();
    if (now - lastChangeSentAt < CHANGE_THROTTLE_MS) return;
    lastChangeSentAt = now;
    socket.emit('trip:changed');
}
